import React from "react";
import { useEffect } from "react";


import { useMaterialUIController, setLayout } from "context";

import Header from "layouts/pages/LandingPage/components/Header";
import Footer from "layouts/pages/LandingPage/components/Footer";
import ContactFormSection from "components/ContactFormSection";




function Contact(): JSX.Element {
    const [, dispatch] = useMaterialUIController();

    useEffect(() => {
        setLayout(dispatch, "page"); // or "page", anything other than "dashboard"
    }, [dispatch]);



    return (
        <>
            <Header brand="SoundMonitor.io" links={["features", "Applications", "Pricing", "Login"]} context="external"/>

            <ContactFormSection />

            <Footer />
        </>
    );
}

export default Contact;
